module.exports = __webpack_public_path__ + "img/clian3.8c2e506f.png";